import { supabase } from "@/utils/supabase";

const FUNCTIONS_URL = `${process.env.VUE_APP_SUPABASE_URL}/functions/v1`;

// Edge Function 호출 (JWT 인증) — BillingApi.callFn 과 동일 패턴
async function callFn(path, body) {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session) throw new Error("E_NOT_LOGGED_IN");

  const res = await fetch(`${FUNCTIONS_URL}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      apikey: process.env.VUE_APP_SUPABASE_KEY,
      Authorization: `Bearer ${session.access_token}`,
    },
    body: JSON.stringify(body || {}),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw Object.assign(new Error(json.message || "E_REQUEST_FAILED"), { detail: json });
  }
  return json;
}

export default {
  // OBS 토큰: 있으면 그대로 반환, 없으면 생성 (멱등 — OBS 링크 버튼/Reveal용)
  //  petId 지정 시 그 펫(소유 검증), 미지정 시 서버가 첫 펫으로 폴백.
  async ensureToken(petId) {
    const { token } = await callFn("/broadcast/token/generate", { mode: "ensure", petId });
    return token;
  },
  // OBS 토큰 재발급 (회전 — 기존 OBS 링크 즉시 무효화)
  async regenerateToken(petId) {
    const { token } = await callFn("/broadcast/token/generate", { mode: "regenerate", petId });
    return token;
  },
};
